<template>
  <div class="nav sidebar-list flex-column">
    <template v-for="item in links">
      <template v-if="item.isExpendable && !item.hidden">
        <b-nav-toggle :target="item.expendableId" class="sidebar-link">
          <template #default="{expanded}">
            <b-nav-item :class="{'active': expanded}">
              <component :is="item.icon" class="mr-2"></component>
              {{ item.title }}
              <caret-down-icon v-if="expanded"></caret-down-icon>
              <caret-left-icon v-else></caret-left-icon>
            </b-nav-item>
          </template>
        </b-nav-toggle>
        <b-collapse :id="item.expendableId" accordion="sidebar-accordion">
          <b-nav-item
            v-for="underItem in underlinks[item.underlinksIndex]"
            :key="underItem.route"
            :to="underItem.route"
            class="sidebar-link sidebar-underlink">
            <span class="pl-4 ml-2"> {{ underItem.title }} </span>
          </b-nav-item>
        </b-collapse>
      </template>
      <template v-else-if="!item.hidden">
        <b-nav-toggle target="sidebar-reset">
          <b-nav-item
            :class="'sidebar-link '+ activeItem(item)"
            :to="item.route">
            <component :is="item.icon" :class="'mr-2 ' + activeItem(item)"></component>
            <div :class="activeItem(item)" style="text-align: left;">
              {{ item.title }}
            </div>
          </b-nav-item>
        </b-nav-toggle>
        <b-collapse id="sidebar-reset" accordion="sidebar-accordion"></b-collapse>
      </template>
    </template>


    <div class="partners-section" v-if="partners.find((partner) => partner.hidden ) && this.$store.getters['brand/brandFeatures'].partenaires">
      <h6 class="partners-title">Partenaire</h6>
    </div>

    <template
      v-for="item in partners"
      v-if="item.hidden">
        <b-nav-toggle
          target="sidebar-reset">
          <b-nav-item :class="'sidebar-link'"  :href="item.link" target="_blank" rel="noopener noreferrer"
                      :key="item.name">
            <div class="w-auto">
              <img :src="item.logo" :alt="item.name" width="24" height="24" class="icon icon-tabler mr-2" />
            </div>
            <div class="">
              {{ item.name }}
            </div>
          </b-nav-item>
        </b-nav-toggle>
    </template>
  </div>
</template>


<script>
import {mapGetters} from 'vuex';

export default {
  name: 'SideMenu',
  props: {
    links: {type: Array},
    underlinks: {type: Array},
    partners: {type: Array}
  },
  computed: {
    ...mapGetters(['pendingAnnouncementsCount', 'pendingTasksCount']),
    activeItem() {
      let domaineActive = this.$route.path.split('/')[1];
      return item =>
        item.routesActiveItem
          ? item.routesActiveItem.filter(routeActiveItem => routeActiveItem.split('/')[1] === domaineActive).length > 0
            ? 'activeItem'
            : ''
          : '';
    }
  },

};
</script>

<style scoped>
.sidebar-link a {
  color: var(--main-white);
  font-size: var(--title-level-three-font-size);
  display: flex;
  align-items: center;
  padding: 12px 11px;
  text-align: left;
  font-family: "Montserrat-Regular", "Arial", sans-serif;
}

.sidebar-link a:hover,
.sidebar-link a.router-link-exact-active,
.sidebar-link.child-active a {
  background-color: var(--background-grey);
  color: var(--main-color);
}

.active a {
  background-color: var(--background-grey);
  color: var(--main-color);
}

.sidebar-underlink a {
  font-family: "Montserrat-Regular", "Arial", sans-serif;
  color: var(--background-grey);
  background-color: var(--main-color);
}

.sidebar-underlink a:hover,
.sidebar-underlink a.router-link-exact-active,
.sidebar-underlink.child-active a {
  color: var(--main-color);
  background-color: var(--background-grey);
  font-family: "Montserrat-Bold", "Arial", sans-serif;
}

.navbar-toggler {
  padding: 0;
  border: 0;
  margin-top: 0;
}

.activeItem {
  background-color: var(--background-grey);
  color: var(--main-color);
  font-family: "Montserrat-Bold", "Arial", sans-serif;
}

.badge-annonce {
  margin-left: 2em;
  background-color: var(--main-red);
  color: white;
  font-weight: bold;
  padding: 2px 12px;
  border-radius: 15px;
  height: 2em;
  width: min-content;
  display: flex;
  justify-content: center;
  align-items: center;
}


.partners-section {
  padding-top: 10px;
  padding-left: 10px;
}

.partners-title {
  color: #6D84C4;
  font-size: var(--title-level-three-font-size);
  margin-bottom: 10px;
  font-family: "Montserrat-Regular", "Arial", sans-serif;

}



</style>



// WEBPACK FOOTER //
// src/views/menus/SideMenu.vue